import { t } from 'ember-intl';
import { array } from '@ember/helper';
import QuestionsLoanTypesCard from 'tio-employee/components/questions/loan-types-card';
import QuestionsNumberedStep from 'tio-employee/components/questions/numbered-step';
import { VStack } from 'tio-ui/components/layout';
import SectionPanel from 'tio-ui/components/section-panel';
import {
  PhPercent,
  PhPause,
  PhCurrencyDollar,
  PhChartBar,
  PhWarning,
  PhCaretDoubleRight,
  PhThumbsUp,
  PhListChecks,
} from 'ember-phosphor-icons';

<template>
  <VStack class="gap-6">
    <SectionPanel
      @icon={{PhThumbsUp}}
      @iconColor="green"
      @title={{t "questions_you_have.types_of_student_loans.pros.pros_plus"}}
    >
      <:body>
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <QuestionsLoanTypesCard
            @icon={{PhPercent}}
            @label={{t "questions_you_have.types_of_student_loans.pros.generally_lower_interest"}}
          />
          <QuestionsLoanTypesCard
            @icon={{PhPause}}
            @label={{t
              "questions_you_have.types_of_student_loans.pros.repayment_options_more_favorable_than"
            }}
          />
          <QuestionsLoanTypesCard
            @icon={{PhCurrencyDollar}}
            @label={{t
              "questions_you_have.types_of_student_loans.pros.qualify_for_loan_forgiveness"
            }}
          />
        </div>
      </:body>
    </SectionPanel>

    <SectionPanel
      @icon={{PhWarning}}
      @iconColor="amber"
      @title={{t "questions_you_have.types_of_student_loans.cons.cons_plus"}}
    >
      <:body>
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <QuestionsLoanTypesCard
            @icon={{PhChartBar}}
            @label={{t "questions_you_have.types_of_student_loans.cons.plus_con1"}}
          />
          <QuestionsLoanTypesCard
            @icon={{PhWarning}}
            @label={{t "questions_you_have.types_of_student_loans.cons.plus_con2"}}
          />
          <QuestionsLoanTypesCard
            @icon={{PhCaretDoubleRight}}
            @label={{t "questions_you_have.types_of_student_loans.cons.plus_con3"}}
          />
        </div>
      </:body>
    </SectionPanel>

    <SectionPanel
      @icon={{PhListChecks}}
      @iconColor="violet"
      @title={{t "questions_you_have.how_to_apply.default"}}
    >
      <:body>
        <VStack class="gap-6">
          <QuestionsNumberedStep
            @number="number_one"
            @title="questions_you_have.how_to_apply.pplus_ask_yourself.default"
            @points={{array
              "questions_you_have.how_to_apply.pplus_ask_yourself.point_1"
              "questions_you_have.how_to_apply.pplus_ask_yourself.point_2"
              "questions_you_have.how_to_apply.pplus_ask_yourself.point_3"
              "questions_you_have.how_to_apply.pplus_ask_yourself.point_4"
              "questions_you_have.how_to_apply.pplus_ask_yourself.point_5"
            }}
          />
          <QuestionsNumberedStep
            @number="number_two"
            @title="questions_you_have.how_to_apply.call_fa_office.default"
            @points={{array "questions_you_have.how_to_apply.call_fa_office.point_1"}}
          />
        </VStack>
      </:body>
    </SectionPanel>
  </VStack>
</template>
